import { IoSunny } from "react-icons/io5";
import { IoIosMoon } from "react-icons/io";

export const themedata = [
  {
    title: "Light",
    value: "light",
    icon: <IoSunny/>
  },
  {
    title: "Dark",
    value: "dark",
    icon: <IoIosMoon/>
  },
  {
    title: "Default",
    value: "auto",
    icon: null
  }
]